(function ($, Cobalt, undefined) {
    Cobalt.Permissions = {
        initialize: function () {

            var roleManager = $("#permission-manager");

            var _droppable = null;
            var _dropped = false;
            var _sortableContainer = null;
            var sortable = $('ol.sortable');
            sortable.sortable(
            {
                disableNesting: 'no-nest',
                forcePlaceholderSize: true,
                handle: 'div.drag-handle',
                items: 'li',
                placeholder: 'placeholder',
                tabSize: 25,
                tolerance: 'pointer',
                axis: "y",
                toleranceElement: '> div',
                stop: function (e, ui) {

                    if (_dropped && _droppable != null) {
                        if (_droppable[0] != $(this)[0]) {
                            ui.item.appendTo(_droppable);
                        }
                    }
                    _dropped = false;

                    Cobalt.Permissions.save(true);
                }
            });

            $("ol.sortable").droppable(
            {
                hoverClass: "droppable-hover",
                accept: ".j-permission-item",
                drop: function (evt, ui) {
                    _droppable = $(this);
                    _dropped = true;
                }
            });

            var resetRenameInputs = function () {
                $("li.j-permission-item").find("form").remove();
                $("li.j-permission-item").find("h4").show();
                $("li.j-permission-item").find("h5").show();
            };

            $("li.j-permission-item").on("click", "h4", function (e) {
                resetRenameInputs();
                // Hide the H4 and show an input box
                var $h4 = $(this);
                var $permission = $(this).parents(".j-permission-item");
                var form = $("<form method=\"post\">").attr("action", "/cp/permissions/" + $permission.attr("data-permission-id") + "/set-name").append("<input class=\"j-rename\" name=\"permission-name\" type=\"text\" value=\"" + $(this).text() + "\" />");
                Cobalt.Utils.getRequestVerificationTokenElement().done(function(element) {
                    form.append(element);
                });

                $h4.parent().append(form);
                $h4.hide();
                form.find("input").focus();
                form.ajaxForm(
                {
                    beforeSubmit: function () {
                        form.find("input").attr("readonly", "readonly");
                    },
                    success: function (result) {
                        $.log(result);
                        if (result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
                            form.fadeOut(function () {
                                form.remove();
                                var newTitle = form.find("input").val();
                                $h4.html(newTitle);
                                $h4.fadeIn();
                            });

                        }
                        else {
                            form.find("input").removeAttr("readonly");
                            form.effect("shake", { times: 6 }, 30);
                        }
                    },
                    error: function () {

                    }
                });
            });

            $("li.j-permission-item").on("click", "h5", function (e) {
                resetRenameInputs();
                // Hide the H4 and show an input box
                var $h5 = $(this);
                var $permission = $(this).parents(".j-permission-item");
                var form = $("<form method=\"post\">").attr("action", "/cp/permissions/" + $permission.attr("data-permission-id") + "/set-description").append("<input class=\"j-rename\" name=\"permission-description\" type=\"text\" value=\"" + $(this).text() + "\" />");
                Cobalt.Utils.getRequestVerificationTokenElement().done(function (element) {
                    form.append(element);
                });
                $h5.parent().append(form);
                $h5.hide();
                form.find("input").focus();
                form.ajaxForm(
                {

                    beforeSubmit: function () {
                        form.find("input").attr("readonly", "readonly");
                    },
                    success: function (result) {
                        if (result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
                            form.fadeOut(function () {
                                form.remove();
                                var newTitle = form.find("input").val();
                                $h5.html(newTitle);
                                $h5.fadeIn();
                            });

                        }
                        else {
                            form.find("input").removeAttr("readonly");
                            form.effect("shake", { times: 6 }, 30);
                        }
                    },
                    error: function () {

                    }
                });
            });

            $("div.context-menu").appendTo($("body"));

            $("li.j-permission-item").on("contextmenu", function (e) {
                $("div.context-menu").data("_activePermission", $(this));
                var selectedPermissionGroupID = $(this).parents("li.j-permission-group").attr("data-permission-group-id");

                $("div.context-menu").find("h5").text($(this).attr("data-permission-name"));
                $("div.context-menu").find("[data-permission-group-id]").removeClass("selected");
                $("div.context-menu").find("[data-permission-group-id=" + selectedPermissionGroupID + "]").addClass("selected");
                $("div.context-menu").css(
                {
                    left: e.pageX,
                    top: e.pageY,
                    zIndex: '101'
                }).show();

                var st = (document.documentElement.scrollTop || document.body.scrollTop);
                var wh = (window.innerHeight && window.innerHeight < $(window).height()) ? window.innerHeight : $(window).height();
                if (($("div.context-menu").offset().top + $("div.context-menu").height() - st) > wh) {
                    $("div.context-menu").css("top", (wh - $("div.context-menu").height() - 10) + st);
                }

                return false;
            });
            $("div.context-menu").on("click", "div.item", function (e) {
                if ($(this).hasClass("selected")) {
                    return;
                }
                $("div.context-menu").hide();
                var selectedPermissionGroupID = $(this).attr("data-permission-group-id");
                $("div.context-menu").find("[data-permission-group-id]").removeClass("selected");
                $("div.context-menu").find("[data-permission-group-id=" + selectedPermissionGroupID + "]").addClass("selected");
                // Find the related li
                var $activePermission = $("div.context-menu").data("_activePermission");
                // Move the li to the new group
                var $permissionGroup = roleManager.find("li.j-permission-group[data-permission-group-id=" + selectedPermissionGroupID + "]");
                $permissionGroup.find("ol").append($activePermission);

                var newScrollTop = $activePermission.offset().top + ($activePermission.height() / 2) - ($(window).height() / 2);
                $activePermission.hide();
                var isAnimating = false;
                Cobalt.Permissions.save(false);
                $("body,html,document").animate({ scrollTop: newScrollTop }, 1000, function () {
                    if (isAnimating) return;
                    isAnimating = true;
                    $activePermission.fadeIn('slow');
                });

            });

            $("body").on("click", function (e) {

                if (!$(e.target).hasClass("j-rename") && !$(e.target).hasClass("j-name") && !$(e.target).hasClass("j-description")) {
                    resetRenameInputs();
                }

                if (!$.contains($("div.context-menu")[0], e.target)) {
                    $("div.context-menu").hide();
                }
            });

            Cobalt.Permissions.bindRankLinks();
        },
        save: function (maskForm) {
            var permissionGroups = [];

            $("li.j-permission-group").each(function (i, e) {
                var permissionGroup = $(this);
                var permissionGroupID = parseInt(permissionGroup.attr("data-permission-group-id"));
                var permissionOrders = [];
                permissionGroup.find("li.j-permission-item").each(function (i, e) {
                    var li = $(this);
                    permissionOrders.push({ id: parseInt(li.attr("data-permission-id")), order: li.prevAll().length + 1 });
                });
                permissionGroups.push({ id: permissionGroupID, order: permissionGroup.prevAll().length + 1, permissions: permissionOrders });
            });

            if (maskForm) {
                $("#permission-manager").mask();
            }
            Cobalt.Utils.postWithToken("/cp/permissions/save-order", { 'permission-order': JSON.stringify(permissionGroups) }).done(function() {
                if (maskForm) {
                    setTimeout(function () { $("#permission-manager").unmask() }, 250);
                }
            });
        },
        bindRankLinks: function () {

            $(".j-permission-manager").on("click", "a.j-up", function (e) {
                Cobalt.Permissions.adjustRank($(this), "up");
            });

            $(".j-permission-manager").on("click", "a.j-down", function (e) {
                Cobalt.Permissions.adjustRank($(this), "down");
            });
        },
        adjustRank: function (link, direction) {
            var li = link.parents("li.j-permission-group");

            var ul = li.parent();
            var newOrdinal = li.prevAll().length - 1;

            if (direction == "up") {
                li.fadeOut(300, function () {
                    li.siblings().eq(newOrdinal).before(li);
                    Cobalt.Permissions.save(false);
                    li.fadeIn();
                });
            }
            else {
                if (li.is(":last-child")) {
                    return;
                }
                li.fadeOut(300, function () {
                    li.siblings().eq(newOrdinal + 1).after(li);
                    Cobalt.Permissions.save(false);
                    li.fadeIn();
                });
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Permissions.js